import React from 'react';
import ProfileForm from './ProfileForm';
import SecurityForm from './SecurityForm';

import PageHeader from '../components/PageHeader'

import homeBg from '../../../images/home-bg.jpg';

/* Settings page */
const Settings = () => (
  <div>
    <PageHeader 
      heading="Settings"
      subheading="Manage your account settings"
      backgroundImage={{backgroundImage: `url(${homeBg})`}} />
    
      <div className="container">
        <ul className="nav nav-tabs" role="tablist">
          <li className="nav-item">
            <a className="nav-link active" data-toggle="tab" href="#profile-settings">Profile</a>
          </li>
          <li className="nav-item">
            <a className="nav-link" data-toggle="tab" href="#security-settings">Security</a>
          </li>
        </ul>
        <div className="tab-content">
          <div className="tab-pane active" id="profile-settings" role="tabpanel">
            <h2 className="section-heading">Profile settings</h2>
            <ProfileForm />
          </div>

          <div className="tab-pane" id="security-settings" role="tabpanel">
            <h2 className="section-heading">Security settings</h2>
            <SecurityForm />
          </div>
        </div>
      </div>
  </div>
)

export default Settings



// WEBPACK FOOTER //
// ./src/components/pages/Settings/Settings.js